// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_List from "../../../../../../node_modules/rescript/lib/es6/belt_List.js";

function machine(state, action) {
  if (typeof state === "number") {
    switch (action.TAG | 0) {
      case /* SetTransactionHistory */0 :
          return {
                  TAG: /* TransactionHistory */0,
                  _0: action._0
                };
      case /* SetTransactionHistoryFailed */1 :
          return {
                  TAG: /* Error */1,
                  _0: action._0
                };
      default:
        return /* Init */0;
    }
  } else {
    if (state.TAG !== /* TransactionHistory */0) {
      return state;
    }
    var prevData = state._0;
    switch (action.TAG | 0) {
      case /* SetTransactionHistory */0 :
      case /* SetTransactionHistoryFailed */1 :
          return /* Init */0;
      case /* UpdateTransactionHistory */2 :
          var data = action._0;
          var finalData_wallet_balance = data.wallet_balance;
          var finalData_last_date_timestamp = data.last_date_timestamp;
          var finalData_transactions = Belt_List.concat(prevData.transactions, data.transactions);
          var finalData = {
            wallet_balance: finalData_wallet_balance,
            last_date_timestamp: finalData_last_date_timestamp,
            transactions: finalData_transactions
          };
          return {
                  TAG: /* TransactionHistory */0,
                  _0: finalData
                };
      case /* UpdateWalletBalance */4 :
          var data$1 = action._0;
          if (data$1.is_updated) {
            return {
                    TAG: /* TransactionHistory */0,
                    _0: {
                      wallet_balance: data$1.wallet_balance,
                      last_date_timestamp: prevData.last_date_timestamp,
                      transactions: prevData.transactions
                    }
                  };
          } else {
            return {
                    TAG: /* TransactionHistory */0,
                    _0: prevData
                  };
          }
      case /* UpdateTransactionHistoryFailed */3 :
      case /* UpdateWalletBalanceFailure */5 :
          return {
                  TAG: /* Error */1,
                  _0: action._0
                };
      
    }
  }
}

var StateMachine = {
  machine: machine
};

export {
  StateMachine ,
  
}
/* No side effect */
